// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1804":"b088d558","3251":"9b79cbba","3747":"b088d558","7103":"b088d558","7118":"b088d558","8050":"b088d558","9626":"b088d558","9984":"b088d558"}[chunkId] + ".chunk.css";
};